module.exports = __webpack_public_path__ + "size.800c3bf0.png";